// extracted by mini-css-extract-plugin
export default {"hideOnPrint":"Jsg4jNEmuCm_uU327sX0__hideOnPrint___"};